// ─── STATE INIT — Global runtime state Coach AI ──────────────────────────
//
// Inizializza le strutture di stato globale che sopravvivono cross-modulo
// (esposte su `window` per bare-identifier access dallo <script> classic
// inline e dai builders/generators ESM che leggono via `window.X`).
//
// Pattern PR-3b ADR-0005: state shared via `window.*` invece di import/export
// per evitare race condition al boot (alcuni moduli si caricano deferred via
// `<script type="module">`, altri sync via classic `<script>`). Cleanup
// `window.*` bridge previsto in BKL-067 (sister di questa PR).
//
// Pattern idempotente `window.X = window.X || ...` (o `?? ...`) per safety:
// se lo <script> classic ha già inizializzato la variabile sync al parse time,
// rispetta quel valore. Se main.js esegue prima del classic (improbabile ma
// possibile in alcuni ordering edge case), inizializza al default.
//
// NB: `_pendingRecovery` NON estratto qui — resta nello <script> classic
// perché letto+settato dentro l'auth handler `onAuthStateChange` (PASSWORD_RECOVERY
// case) che gira sync al parse time. Verrà estratto insieme all'auth handler
// in PR 3 (BKL-086) per coerenza.
//
// Estratto da `index.html` <script> inline in PR refactor/bkl016-pr2
// (2026-05-21, completamento ADR-0005 split).

// Stato app principale: profilo utente + conversazione attiva + plans
// generati + measurements. Letto/scritto da builders, generators, ui-*.
window.S = window.S || {
  profile: null,
  conv: [],
  plans: { meal: null, workout: null, stretch: null, spesa: null },
  measurements: [],
  lastMeasurement: null
};

// Plan state: pannello drawer per-piano (open/closed, dataset corrente).
// Letto da ui-plans.js (`window.PS.meal`, `.work`, ecc.).
window.PS = window.PS || {
  meal: null,
  work: null,
  str: null,
  spesa: null
};

// Welcome flags: stato locale onboarding (welcome wizard, legal acceptance,
// email consent, announcement seen). Mirror in-memory di
// `profiles.onboarding_flags` JSONB. Inizializzato qui perché letto sia
// dallo <script> classic inline (onAuthStateChange chain) sia dai moduli
// ESM (ui-onboarding.js). Sopravvive logout/login (reset esplicito in
// `_forceLogoutToLogin`).
window._welcomeFlags = window._welcomeFlags || {};
